import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom'
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { _aboutyouState as _storage, formOptions } from '../_states/_aboutyouState';
import SelectOption from '../helpers/_SelectOption';
import ErrorMessage from '../helpers/_ErrorMessage';
import { useGetData } from '../Services/_services';
import { config } from '../Services/_config';
import { yupResolver } from '@hookform/resolvers/yup';
import { RemainingCharacters } from '../helpers/_RemainingCharacters';

function About() {
  const { control, register, handleSubmit, formState: { errors } } = useForm({mode:"onTouched", resolver: yupResolver(formOptions)})
  //////States
  const [_states, setStates] = useState({
    foreName: _storage.getForeName(),
    surName: _storage.getSurName(),
    contact: _storage.getContact(),
    email: _storage.getEmail(),
    organisation: _storage.getOrganisation(),
    department: _storage.getDepartment(),
    teamContact: _storage.getTeamContact(),
    chkConsent: _storage.getChkConsent(),
    consentText: _storage.getConsentText()
  });
  const showHideElements = { showHideConsentText: _storage.getChkConsent() === "no" ? true : false };
  const [departments, setDepartments] = useState([]);
  /////End

  const { data: orgainisation, loading } = useGetData(config.cisApis.organisationPath);
  const { data: allDepartments  } = useGetData(config.cisApis.departmentsPath);
  const navigate = useNavigate();

  const getDepartments = useCallback((orgCode) => {
    if (orgCode) {
      const depts = allDepartments.filter(x => x.organisation === orgCode);
      if (depts)
        setDepartments(depts);
    }
  },[allDepartments])

  useEffect(() => {
    if (_states.organisation) {
      getDepartments(_states.organisation);
    }
  },[_states.organisation, getDepartments]);

  // scroll to the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const onSubmit = event => {
    navigate('/details');
  };

  return (
    <form className="input-form" onSubmit={handleSubmit(onSubmit)}>
      <main id="main" className="sectionOne">
        <div className="container-fluid">
          <div className="row">
						<div className="col-md-8">
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  <h2>About you </h2>
                  <p>Please provide some details about yourself as the referrer.</p>
                  <p>All fields marked * are mandatory and need to be completed so we can get the best outcome.</p>

									<div className={errors.foreName ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="foreName" className="form-label">Forename*</label>
                    <ErrorMessage id="foreName" error={errors.foreName}/>
                    <Controller name="foreName" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <input {...field} type="text" id="foreName" name="foreName" value={_states.foreName}
													className={`form-control ${errors.foreName ? 'is-invalid' : ''}`}
													aria-invalid={errors.foreName ? "true" : "false"}
													aria-describedby={errors.foreName ? "foreName-error" : ""}
                          {...register('foreName')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setForeName(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value })
                          }}
                        />
                      )}
                    />
                  </div>

									<div className={errors.surName ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="surName" className="form-label">Surname*</label>
                    <ErrorMessage id="surName" error={errors.surName}/>
                    <Controller name="surName" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <input {...field} type="text" id="surName" name="surName" value={_states.surName}
													className={`form-control ${errors.surName ? 'is-invalid' : ''}`}
													aria-invalid={errors.surName ? "true" : "false"}
													aria-describedby={errors.surName ? "surName-error" : ""}
                          {...register('surName')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setSurName(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value })
                          }}
                        />
                      )}
                    />
                  </div>

									<div className={errors.contact ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="contact" className="form-label">Your contact number*</label>
                    <ErrorMessage id="contact" error={errors.contact}/>
                    <Controller name="contact" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <input {...field} type="text" id="contact" name="contact" value={_states.contact}
													className={`form-control ${errors.contact ? 'is-invalid' : ''}`}
													aria-invalid={errors.contact ? "true" : "false"}
													aria-describedby={errors.contact ? "contact-error" : ""}
                          {...register('contact')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setContact(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value })
                          }}
                        />
                      )}
                    />
                  </div>

									<div className={errors.email ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="email" className="form-label">Your email*</label>
                    <p>Please provide your email so we can send confirmation of referral</p>
                    <ErrorMessage id="email" error={errors.email}/>
                    <Controller name="email" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <input {...field} type="text" id="email" name="email" value={_states.email}
													className={`form-control ${errors.email ? 'is-invalid' : ''}`}
													aria-invalid={errors.email ? "true" : "false"}
													aria-describedby={errors.email ? "email-error" : ""}
                          {...register('email')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setEmail(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value })
                          }}
                        />
                      )}
                    />

                  </div>

									<div className={errors.organisation ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="organisation" className="form-label">Your organisation*</label>
                    <ErrorMessage id="organisation" error={errors.organisation}/>
                    <Controller name="organisation" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <select  {...field} id="organisation" name="organisation" value={_states.organisation}
													className={`form-control ${errors.organisation ? 'is-invalid' : ''}`}
													aria-invalid={errors.organisation ? "true" : "false"}
													aria-describedby={errors.organisation ? "organisation-error" : ""}
                          {...register('organisation')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setOrganisation(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value });
                            setDepartments([]);
                            getDepartments(e.target.value);
                          }}
                        >
                          <SelectOption isParent={true} loading={true} data={orgainisation} selectedkey={_states.organisation} />
                        </select>
                      )}
                    />
                  </div>

									<div className={errors.department ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="department" className="form-label">Department*</label>
                    <ErrorMessage id="department" error={errors.department}/>
                    <Controller name="department" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <select  {...field} id="department" name="department" value={_states.department}
													className={`form-control ${errors.department ? 'is-invalid' : ''}`}
													aria-invalid={errors.department ? "true" : "false"}
													aria-describedby={errors.department ? "department-error" : ""}
                          {...register('department')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setDepartment(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value })
                          }}
                        >
                          <SelectOption isParent={false} data={departments} loading={false} selectedkey={_states.department} />
                        </select>
                      )}
                    />
                  </div>

									<div className={errors.teamContact ? 'form-group form-group--error' : 'form-group'}>
                    <label htmlFor="teamContact" className="form-label">Team contact*</label>
                    <p>In case we are unable to contact you please provide contact details of your team, unit or colleagues. </p>
                    <ErrorMessage id="teamContact" error={errors.teamContact}/>
                    <Controller name="teamContact" control={control}
                      render={({ field: { value, onChange, ...field } }) => (
                        <textarea {...field} type="text" id="teamContact" name="teamContact" value={_states.teamContact}
													className={`form-control ${errors.teamContact ? 'is-invalid' : ''}`}
													aria-invalid={errors.teamContact ? "true" : "false"}
													aria-describedby={errors.teamContact ? "teamContact-error" : ""}
                          {...register('teamContact')} onChange={(e) => {
                            onChange(e.target.value);
                            _storage.setTeamContact(e.target.value);
                            setStates({ ..._states, [e.target.name]: e.target.value })
                          }}
                        />
                      )}
                    />
                    <p>You can enter up to 200 characters</p>
                    <RemainingCharacters maxNoCharacters={200} inputValue={_states.teamContact} />
                  </div>

									<div className={errors.chkConsent ? 'form-group form-group--error' : 'form-group'}>
                    <fieldset>
                      <legend className="sr-only">Is the person being referred aware of this referral and given consent?</legend>
                      <label className="form-label">Is the person being referred aware of this referral and given consent?*</label>
                      <p>It could be that the consent has come from an indirect source such as a family member due to person’s physical or mental circumstances. </p>
                      <FormControl>
                        <ErrorMessage id="chkConsent" error={errors.chkConsent}/>
                        <RadioGroup {...register('chkConsent')} name="chkConsent" id="chkConsent" value={_states.chkConsent}
                          onChange={(e) => {
                            setStates({ ..._states, [e.target.name]: e.target.value })
                            _storage.setChkConsent(e.target.value);
                            showHideElements.showHideConsentText = e.target.value === "no" ? true : false;
                          }}
                        >
                          <FormControlLabel value="yes"  {...register('chkConsent')} control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" {...register('chkConsent')} control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>

                      {showHideElements.showHideConsentText &&
                        <div className="panel panel-border-narrow js-hidden" id="no-consent-reason">
                          <label htmlFor="consentText" className="form-label">If no, could you please explain why*</label>
                          <ErrorMessage id="consentText" error={errors.consentText}/>
                          <Controller name="consentText" control={control}
                            render={({ field: { value, onChange, ...field } }) => (
                              <textarea {...field} rows="4" type="text" id="consentText" name="consentText" value={_states.consentText}
																className={`form-control ${errors.consentText ? 'is-invalid' : ''}`}
																aria-invalid={errors.consentText ? "true" : "false"}
																aria-describedby={errors.consentText ? "consentText-error" : ""}
                                {...register('consentText')} onChange={(e) => {
                                  onChange(e.target.value);
                                  _storage.setConsentText(e.target.value);
                                  setStates({ ..._states, [e.target.name]: e.target.value })
                                }}
                                />
                            )}/>
                          <p>You can enter up to 200 characters</p>
                            <RemainingCharacters maxNoCharacters={200} inputValue={_states.consentText} />
                        </div>
                      }
                    </fieldset>
                  </div>

									<div className="form-group form-group--progbuttons">
                    <button className="btn  btn-light btn-lg" type="button"
                      onClick={(event) => {
                        navigate('/');
                      }}
                    >Previous</button>
                    <button className="btn btn-primary btn-lg" type="submit">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </form>
  );
};
export default About;
